<div fxLayout="column" fxLayoutAlign="center center" fxFlex="100%">
  <img
    [src]="'../assets/img/' + maintenance.mode + '_grey.png'"
    alt="System Unavailable"
  />
  <hr />
  <h1>{{ maintenance.title }}</h1>
  <p [innerHTML]="maintenance.description | safeHtml"></p>
</div>
